import React from 'react';
import { Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';

const FinalRecommendation = ({ formData, handleChange }) => {
    return (
        <Stack spacing={2}>
            <MaterialTypography variant="h6" fontWeight="bold">
                Final QA Recommendation
            </MaterialTypography>
            <MaterialInput
                name="finalRecommendation"
                value={formData.finalRecommendation}
                onChange={handleChange}
                placeholder="Enter final recommendation..."
                multiline
                rows={5}
                fullWidth
            />
        </Stack>
    );
};

export default FinalRecommendation;
